import { RuntimeManager } from './runtime/RuntimeManager.js';
import { UIManager } from './ui/UIManager.js';
import { ErrorCapture } from './capture/ErrorCapture.js';
import { APIGlue } from './api/APIGlue.js';
import { WindowManager } from './windows/WindowManager.js';
import { CodeInspector } from './analysis/CodeInspector.js';
import { TableRenderer } from './ui/TableRenderer.js';
import { ServiceManager } from './services/ServiceManager.js';
import { ThemeManager } from './themes/ThemeManager.js';
import { SettingsWindow } from './ui/SettingsWindow.js';

class DevTools {
  constructor(options = {}) {
    this.options = {
      port: 9351,
      pixelatedText: true,
      autoStart: false,
      ...options
    };

    this.runtimeManager = new RuntimeManager(this);
    this.uiManager = new UIManager(this);
    this.errorCapture = new ErrorCapture(this);
    this.apiGlue = new APIGlue(this);
    this.windowManager = new WindowManager(this);
    this.codeInspector = new CodeInspector(this);
    this.tableRenderer = new TableRenderer(this);
    this.serviceManager = new ServiceManager(this);
    this.themeManager = new ThemeManager(this);
    this.settingsWindow = new SettingsWindow(this);

    this.isActive = false;
  }

  init() {
    this.errorCapture.init();
    this.uiManager.init();
    this.apiGlue.init();
    this.themeManager.loadPreferences();
    this.isActive = true;
    console.log('DevTools initialized');
  }

  destroy() {
    this.errorCapture.destroy();
    this.uiManager.destroy();
    this.windowManager.closeAll();
    this.isActive = false;
  }
}

// Auto-initialize if not in module environment
if (typeof window !== 'undefined') {
  window.DevTools = DevTools;
}

export default DevTools;